import React, { FC } from 'react'
import styled from 'styled-components'

import { svgURL } from '@Globals/Cloudinary'

interface YOLOFlagIconProps {
  country: string
}

const ImageTag = styled.img`
  width: 26px;
  height: auto;
`

export const YOLOFlagIcon: FC<YOLOFlagIconProps> = ({ country }) => {
  if (!country) {
    return null
  }

  return (
    <ImageTag
      alt=""
      src={svgURL(`frontend/country-flags/flag-${country}.svg`)}
    />
  )
}
